module.exports = __webpack_public_path__ + "img/Must be an Agent to Register_th.b26f972.png";